import React, { useState } from "react";
import { Button, Input, message, Menu, Dropdown } from "antd";
import { OrderedListOutlined, DownOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchasePoModel } from "../purchasePoModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YHModal } from "@/components/YHModal";
import { usePurchasePoDetailsModel } from "./details/purchasePoDetailsModel";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { drawerVisible, selectedRow, setDrawerVisible, syncData, selectedRowKeys, descTotal, rowsDescTotal, invalidateData, loadData, setSettleVisible, listExport,
        detailsExport } = usePurchasePoModel();

    const { addNav, findNav, selectNav, switchNavState, selectedNavId, replaceNav } = useNavModel();
    const [cancellationVal, setCancellationVal] = useState<string>("")
    const [visible, setVisible] = useState(false);
    const { setDetailDataSource, setDetailEditForm, Settle, WhConfirm, } = usePurchasePoDetailsModel()
    const onEdit = () => {
        if (selectedRow.status === "purchase.change") {
            // globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been cancelled and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRow.status === "purchase.settle") {
            // globalPrompt("message", { text: "该单据已结算，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been settled and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRow.status === "purchase.completely-io") {
            // globalPrompt("message", { text: "该单据已入库，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been stocked in and cannot be edited."], type: "warning" });

            return;
        }
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let supplierEditKey = "3-1-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.purchaseCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "采购单跳转详情",
                title: Locale["Jump to the detail page of Purchase doc."],
                type: "warning",
                // text: "您还有采购单详情未保存，是否跳转",
                text: Locale["The detail page of Purchase doc has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.purchaseCode as string, mode: "edit" });
                    setDetailDataSource([])
                    setDetailEditForm({})
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行查看", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "3-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.purchaseCode as string, mode: "look", },
            true
        );
        // let isFindNav = findNav(supplierEditKey);
        // if (!isFindNav) {
        //     addNav(supplierEditKey, { id: selectedRowKeys[0], mode: "look" });
        // } else {
        //     globalPrompt("modal", {
        //         title: "采购单跳转查看",
        //         type: "warning",
        //         text: "您还有采购单查看未关闭，是否跳转",
        //         okText: "跳转未保存页",
        //         onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
        //         cancelText: "打开新页签",
        //         onCancel: () => {
        //             switchNavState(supplierEditKey, { id: selectedRowKeys[0], mode: "look" });
        //         }
        //     })
        // }
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行作废", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            // title: "采购单作废",
            title: Locale["Cancel the Purchase doc."],
            type: "error",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    purchaseCode: selectedRow.purchaseCode
                    // val
                }
                invalidateData(obj)
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onSettle = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setSettleVisible(true)
        // let { purchaseCode, id } = selectedRow
        // globalPrompt("modal", {
        //     // title: "采购单结算",
        //     title:Locale["Settle the Purchase doc."],
        //     type: "success",
        //     text: "",
        //     // <><span>请输入作废原因</span>
        //     //     <Input onChange={(e) => { val = e.target.value }} /></>,
        //     // okText: "确定",
        //     okText: Locale["Yes No"],
        //     onOk: async () => {
        //         let retData = await Settle({ purchaseCode, id })
        //         // retData ? message.success("结算成功") && loadData() : message.error("结算失败")
        //         retData ? message.success(Locale["Successfully settled"]) && loadData() : message.error(Locale["Unsuccessfully settled"])
        //     },
        //     // cancelText: "取消",
        //     cancelText: Locale["cancel"],
        //     onCancel: () => {
        //     }
        // })

    }
    const onWhConfirm = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        let { purchaseCode, id } = selectedRow
        globalPrompt("modal", {
            // title: "采购单入库",
            title: Locale["Stock in the Purchase doc."],
            type: "success",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await WhConfirm({ purchaseCode, id })
                // retData ? message.success("入库成功") && loadData() : message.error("入库失败")
                retData ? message.success(Locale["Successfully stocked in"]) && loadData() : message.error(Locale["Unsuccessfully stocked in"])

            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })

    }
    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={listExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            // resCode={"PurchaseStockInAdd"}
            resCode={ResourcesAuthBtn[mianCode]["PurchaseStockInAdd"]}
            // resCode={ResourcesAuthBtn}
            onClick={() => addNav("3-1-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="PurchaseStockInEdit"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseStockInEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="PurchaseStockInView"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseStockInView"]}
            onClick={onLook}
            // name="查看"
            name={Locale["View"]}
        />
        <AuthButton
            // resCode="PurchaseStockInPayment"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseStockInPayment"]}
            onClick={onSettle}
            // name="结算"
            name={Locale["Settle"]}
        />
        <AuthButton
            // resCode="PurchaseStockInStockin"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseStockInStockin"]}
            onClick={onWhConfirm}
            // name="出库"
            name={Locale["Stock in"]}
        />
        <AuthButton
            // resCode="PurchaseStockInCancel"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseStockInCancel"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => addNav("3-1-1", { id: "", mode: "add" })}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onLook}
        >查看</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onSettle()}
        >结算</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onWhConfirm()}
        >入库</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={cancellation}
        >作废</Button> */}
    </>;


    const desc: IDescription[] = [
        {
            // label: "采购数量",
            label: Locale["Purchase Qty"],
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : (rowsDescTotal.totalNum),
            color: DescriptionColorEnum.red
        },
        {
            // label: "采购金额",
            label: Locale["Purchase Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "应付金额",
            label: Locale["Payable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivedAmount : formatNum(rowsDescTotal.receivedAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已付金额",
            label: Locale["Paid Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.amountReceived : formatNum(rowsDescTotal.amountReceived),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <>
            <YhBox title={<></>} descriptions={desc} action={action} >
                <DataTable />
            </YhBox>
            <YHModal
                visible={visible}
                onOk={() => { }}
                onCancel={() => setVisible(false)}
            />
        </>
    )
}